export interface Role {
  code: string;
  clazz?: string;
  name: string;
  description?: string;
  isHierarchical?: boolean;
  isDerived?: boolean;
  hasPrimary?: boolean;
}

export class RoleModel implements Role {
  code: string;
  clazz?: string;
  name: string;
  description?: string;
  isHierarchical?: boolean;
  isDerived?: boolean;
  hasPrimary?: boolean;

  static create(props: Partial<Role>): Role | null {
    if (!props || !props.code) {
      return null;
    }

    return new RoleModel(props);
  }

  constructor(props: Partial<Role>) {
    this.code = props.code || '';
    this.clazz = 'edu.ucdavis.gs.people.Role';
    this.name = props.name || props.code || '';
    this.description = props.description;
    this.isHierarchical = props.isHierarchical || this.code.includes('SUBUNIT');
    this.isDerived = props.isDerived;
    this.hasPrimary = props.hasPrimary;
  }
}



// WEBPACK FOOTER //
// ./src/gs-core/common/models/role.ts